<script setup lang="ts">
import { ref } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faGear } from '@fortawesome/pro-regular-svg-icons'

const auth = useAuthStore()
const settingsOpen = ref(false)
</script>

<template>
  <div
    v-if="auth.isAuthenticated"
    class="action-buttons"
  >
    <CommonButton
      aria-label="Innstillinger"
      shape="icon"
      @click="settingsOpen = true"
    >
      <FontAwesomeIcon :icon="faGear" />
    </CommonButton>
  </div>
  <AppSettings
    v-if="auth.isAuthenticated"
    :open="settingsOpen"
    @close="settingsOpen = false"
  />
</template>

<style lang="scss" scoped>
  .action-buttons {
    display: flex;
    gap: 1em;
  }
</style>
